export default {
  currentScheme: state => state.scheme,
  currentLogo: state => state.logo
};
